"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeacherCannotAccessClass = void 0;
const client_library_1 = require("@seneca/client-library");
class TeacherCannotAccessClass extends client_library_1.ExtendableError {
    constructor(classId) {
        super(`Teacher is not allowed to access class ${classId}`);
    }
}
exports.TeacherCannotAccessClass = TeacherCannotAccessClass;
//# sourceMappingURL=TeacherCannotAccessClass.js.map